// src/theme.js
import { alpha, createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#054693', dark: '#04356f', light: '#2f6eb4' },
    secondary: { main: '#2bbf6e' },
    success: { main: '#15803d' },
    warning: { main: '#d97706' },
    error: { main: '#b91c1c' },
    background: { default: '#f6f9fc', paper: '#ffffff' },
    text: { primary: '#0f172a', secondary: '#64748b' },
    divider: '#dbe6f3',
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: '"Plus Jakarta Sans", "Inter", "Segoe UI", Roboto, Arial, sans-serif',
    h4: { fontWeight: 800, letterSpacing: '-0.015em' },
    h5: { fontWeight: 750, letterSpacing: '-0.01em' },
    h6: { fontWeight: 700, letterSpacing: '-0.01em' },
    button: { fontWeight: 700, letterSpacing: '0.01em' },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundImage: 'radial-gradient(circle at 12% -10%, rgba(5, 70, 147, 0.08) 0%, rgba(5, 70, 147, 0) 36%)',
          backgroundAttachment: 'fixed',
        },
      },
    },
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: {
          borderRadius: 12,
          border: `1px solid ${alpha('#054693', 0.08)}`,
          transition: 'box-shadow 180ms ease, transform 180ms ease, border-color 180ms ease',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 10,
          paddingInline: 16,
          transition: 'transform 140ms ease, box-shadow 180ms ease, background-color 180ms ease',
          '&:hover': {
            transform: 'translateY(-1px)',
          },
        },
        containedPrimary: {
          boxShadow: `0 8px 20px ${alpha('#054693', 0.26)}`,
          '&:hover': {
            backgroundColor: '#04356f',
            boxShadow: `0 10px 24px ${alpha('#054693', 0.34)}`,
          },
        },
        outlinedPrimary: {
          borderColor: alpha('#054693', 0.36),
          '&:hover': {
            borderColor: '#054693',
            backgroundColor: alpha('#054693', 0.06),
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          fontWeight: 600,
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          transition: 'background-color 140ms ease',
          '&:hover': {
            backgroundColor: '#f8fbff',
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 14,
          border: `1px solid ${alpha('#054693', 0.14)}`,
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: '#054693',
          height: 3,
          borderRadius: 3,
        },
      },
    },
  },
});

export default theme;
